import state from './userState'
import mutations from './userMutations'
import actions from './userActions'

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
